<template>
    <div class="container">
        <b-container fluid>
            <b-row style="margin-top:100px;text-align: left;">
                    <b-col>
                        <h3>Projects and Experiments</h3>
                    </b-col>
            </b-row>
            <b-row>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <div id="boxBg">
                        <ul>
                            <li>Data used from <span style="color:red;font-weight: bold;">1713</span> experiments from <span style="color:red;font-weight: bold;">4</span> projects.</li>
                            <li> Among <span style="color:red;font-weight: bold;">1713</span> experiments, generating <span style="color:red;font-weight: bold;">86GB</span> amount of data.</li>
                            <li> Raw FASTQ reads were used for entropy analysis, resulting in <span style="color:red;font-weight: bold;"> 3</span> groups for mouse and humans.</li>
                            <li>We limited our analysis to taxa that were supported by at least five sequencing reads in both samples of the human-mouse pairs.</li>
                        </ul>
                    </div>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h3>Data collection</h3>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <b-row>
                        <b-col>
                            <img src="../assets/Figure_S1_protocal.jpg" fluid width="500px"/>
                        </b-col>
                        <b-col>
                            <br>
                            <p>The research articles were filtered based on: </p> 
                            <ul>
                                <li>The search included only human to mice FMT experiments </li>
                                <li>Exclude any genetically altered mice experiments</li>
                                <li>Limited only to germ free mice</li>
                                <li>Exclude any mice experiments involving antibiotics</li>
                                <li>Filter based on experiment sequencing protocol and experiments with fewer samples.</li>
                            </ul>
                            <div id="boxBg">
                                <b>Note:</b>  <br>
                                Initial phase of data collection was done during April 2018, on PubMed and NCBI SRA databases for publications and/or deposited metagenomic sequencing data from human-to-mouse FMT experiments. The data collection steps were repeated again in March 2020 before publication and found similar FMT experiments ,but filtered out due to not matching the analysis conditions.
                            </div>
                        </b-col>
                    </b-row>
                </b-col>                
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h3>Projects</h3>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                        <download-csv
                            :data   = "tab_Proj_data">
                        Meta data for the projects used is available for download here &nbsp;
                        <font-awesome-icon icon="download"></font-awesome-icon>
                        </download-csv>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-table
                        responsive
                        show-empty
                        :busy.sync="isProjBusy"
                        :striped="false"
                        :outlined="true"
                        :items="tab_Proj_data"
                        :fields="tab_Proj_fields"
                    >
                        <template  v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                        <!-- <template v-slot:cell(index)="data">
                            {{ data.index + 1 }}
                        </template> -->
                        <template v-slot:cell(projectId) ="row">
                                <a v-bind:href="'https://www.ncbi.nlm.nih.gov/bioproject/' + row.item.projectId.trim()" target="_blank">{{row.item.projectId.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                        </template>
                         <template v-slot:cell(description)="row">
                            <read-more more-str="read more" :text="row.item.description" link="#" less-str="read less" :max-chars="150" style="text-align:justify"></read-more>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>                    
                </b-col>
            </b-row>    
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h3>Entropy classification</h3>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <div id="boxBg">
                        <ul>
                            <li>Human gut microbes could be classified into three enterotypes, each with distinct leading species.Our results showed that the mixed data from humans and mice can also form three enterotypes:
                                <ol>
                                    <li>Mouse groups <b>I,II,III</b></li>
                                    <li>Human groups <b>I,II,III</b></li>
                                </ol>
                            </li>
                            <li> Human-mouse pair details can be downloaded from  <router-link to="/pairbrowser">Browse pairs</router-link></li>
                            <li> The total species and genus list from the analysis can be downloaded from <router-link to="/speciesgenusbrowse">Browse Species/Genus</router-link> </li>
                            <li> The Relative abundance at species and genus levels for each experiments is available in the pair info page for each experiment pairs. </li>
                        </ul>
                    </div>
                    <br>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data () {
        return {
            server_add : this.$hostname,
            isProjBusy:true,
            tab_Proj_data:[],
            tab_Proj_fields:[
                { key:'index',label:''},
                { key: 'projectId', label: 'Project ID'},
                { key: 'title', label: 'Title', sortable: true},
                { key: 'doi', label: 'DOI ID'},
                { key: 'description', label: 'Description'},
            ],
        }
    },
    mounted() {
        this.loadProjectInfo()
    },
    methods: {
        loadProjectInfo(){
            this.isProjBusy = true
            axios.post(this.server_add+'query/listProj',
            {
            }).then(retDat => {
                if(retDat.status === 200){
                    this.tab_Proj_data = retDat.data
                    this.isProjBusy = false
                }
            }).catch(err => {
                console.log(err)
            })
        }
    },
}
</script>

<style lang="less">
#boxBg{
    background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 20px;
    padding-left: 20px;
    text-align: justify;
}
</style>